import { isInactive } from 'domain/plans';

const validateValues =
  (...keys) =>
  (context: MovingStateMachineContext, event) => {
    return keys.every(key => !!context[key] || !!event.data?.[key]);
  };

export const CONED_UTILITY_ID = 2337;

// ConEd accounts go through diff utility flow due to 2FA
const isConEdUtility = (context: MovingStateMachineContext) => {
  return context.utility.id === CONED_UTILITY_ID;
};

const isEvergreenAccount = (context: MovingStateMachineContext) => {
  const { selectedUtilityAccount } = context;
  return selectedUtilityAccount?.utility.evergreenOnly;
};

const isSameUtility = (context: MovingStateMachineContext) => {
  const { utility, selectedUtilityAccount } = context;
  return utility.id === selectedUtilityAccount?.utility.id;
};

const isWaitlistUtility = (context: MovingStateMachineContext) => {
  const { utility } = context;
  return !utility.vnmEligible;
};

const ableToDiscoverAccounts = (context: MovingStateMachineContext) => {
  return (
    context.selectedUtilityAccount?.utilityCredential.verificationStatus ===
    'correct'
  );
};

const shouldUseSameUtilityFlow = (context: MovingStateMachineContext) => {
  return (
    isSameUtility(context) &&
    !isConEdUtility(context) &&
    !!context.selectedPlan &&
    !isInactive(context.selectedPlan.status) &&
    !isEvergreenAccount(context) &&
    !isWaitlistUtility(context) &&
    ableToDiscoverAccounts(context)
  );
};

const selectedUtilityAccountIsSet = validateValues('selectedUtilityAccount');
const zipCodeAndUtilityAreSet = validateValues('zipCode', 'utility');
const accountsIsSet = validateValues('accounts');

const shouldAddPaymentMethod = (context: MovingStateMachineContext) => {
  return (
    context.requiresPaymentMethod &&
    context.selectedPlan?.paymentMethodId === null &&
    !isWaitlistUtility(context)
  );
};

export const guards = {
  selectedUtilityAccountIsSet,
  zipCodeAndUtilityAreSet,
  accountsIsSet,
  shouldUseSameUtilityFlow,
  shouldAddPaymentMethod,
  isWaitlistUtility,
};
